import { ProfileData, ProfilePublicData } from "./interfaces/UserProfileResponse";
import api from '../apiInstance';
import { AxiosResponse } from "axios";
import { ProfileEditPageData, ProfileUpdateData } from "./interfaces/Profile";

export  const getUserProfile = async (profileId: number): Promise<AxiosResponse<ProfileData>> => {
    return api.get<ProfileData>(process.env.REACT_APP_RENTIC_API_URL! + '/profile/' + profileId);
}

export const getUserPublicProfile = async (profileId: number): Promise<AxiosResponse<ProfilePublicData>> => {
    return api.get<ProfilePublicData>(process.env.REACT_APP_RENTIC_API_URL! + '/profile/public/' + profileId);
}

export const getProfileEditData = async (): Promise<ProfileEditPageData> => {
    const res = await api.get<ProfileEditPageData>(process.env.REACT_APP_RENTIC_API_URL! + '/profile/edit');

    return res.data;
}

export const deleteProfile = async (): Promise<string> => {
    const res = await api.delete<string>(process.env.REACT_APP_RENTIC_API_URL! + '/files/picture/delete_profile_pic');

    return res.data;
}

export const updateProfile = async (data: ProfileUpdateData): Promise<number> => {
    const res = await api.patch<number>(process.env.REACT_APP_RENTIC_API_URL! + '/profile/update', data);

    return res.data;
}